module.exports = __webpack_public_path__ + "img/sayings.9fb1e14.jpg";